import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { Text, Loader, Box, Stack, Center, Modal, Button } from "@mantine/core";
import { Rizvoice } from "../stores/Rizvoice";
import GenericInvoiceQR from "./genericInvoiceQR";

const PaySubscription = observer(({ rizvoice }: { rizvoice: Rizvoice }) => {
  return (
    <Modal
      opened={rizvoice.subscriptionPaymentPayRequest.length > 0}
      onClose={() => rizvoice.setSubscriptionPaymentPayRequest("")}
      title="Lightning Payment"
    >
      <Stack>
        {rizvoice.subscriptionPaymentPayRequest.length > 0 && (
          <>
            <GenericInvoiceQR
              modelInstance={rizvoice}
              invoiceString={rizvoice.subscriptionPaymentPayRequest}
              whatIsItFor={"Extend node uptime:"}
            />
            {rizvoice.subscriptionPaymentJustPaid && (
              <>
                <Text size="xl" ta="center">
                  Payment Received
                </Text>
                <Button component="a" href="/nodes">
                  Click here to continue
                </Button>
              </>
            )}
          </>
        )}
      </Stack>
    </Modal>
  );
});

export default PaySubscription;
